module.exports = __webpack_public_path__ + "static/media/andita-staff-web-hubton.918fdc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/andita-staff-web-hubton.png
// module id = 184
// module chunks = 0